import type { ReactNode } from 'react';

// ─── Specialty icons ───────────────────────────────────────────────────────────

export function StethoscopeIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path d="M13 5 L9 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.85" />
      <path d="M27 5 L31 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.85" />
      <path
        d="M9 12 C8 20 14 23 20 23 C26 23 32 20 31 12"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.75"
      />
      <line x1="20" y1="23" x2="20" y2="30" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <circle cx="20" cy="34" r="4.5" stroke="currentColor" strokeWidth="2.5" opacity="0.9" />
      <circle cx="20" cy="34" r="1.8" fill="currentColor" opacity="0.4" />
    </svg>
  );
}

export function PhysiotherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="20" cy="8" r="4" fill="currentColor" opacity="0.8" />
      <path
        d="M20 13 L20 26 M20 26 L14 34 M20 26 L26 34 M20 17 L12 22 M20 17 L28 22"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MassageTherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M8 28 C8 28 12 18 20 18 C28 18 32 28 32 28"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M12 22 C12 22 14 14 20 14 C26 14 28 22 28 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.6"
      />
      <ellipse cx="20" cy="30" rx="10" ry="4" fill="currentColor" opacity="0.15" />
      <circle cx="20" cy="10" r="3" fill="currentColor" opacity="0.7" />
    </svg>
  );
}

export function OsteopathyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <rect x="17" y="4"  width="6" height="5" rx="2" fill="currentColor" opacity="0.8" />
      <rect x="17" y="11" width="6" height="5" rx="2" fill="currentColor" opacity="0.7" />
      <rect x="17" y="18" width="6" height="5" rx="2" fill="currentColor" opacity="0.6" />
      <rect x="17" y="25" width="6" height="5" rx="2" fill="currentColor" opacity="0.5" />
      <rect x="17" y="32" width="6" height="4" rx="2" fill="currentColor" opacity="0.4" />
      <path d="M23 6.5 L28 6.5"  stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path d="M23 13.5 L27 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path d="M23 20.5 L26 20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path d="M17 6.5 L12 6.5"  stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path d="M17 13.5 L13 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path d="M17 20.5 L14 20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}

export function ChiropracticIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M20 4 C27 4 27 11 20 14 C13 17 13 24 20 27 C27 30 27 36 20 36"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.8"
      />
      <circle cx="24" cy="9"  r="2" fill="currentColor" opacity="0.55" />
      <circle cx="16" cy="20" r="2" fill="currentColor" opacity="0.55" />
      <circle cx="24" cy="31" r="2" fill="currentColor" opacity="0.55" />
      <path d="M7 19 L12 22 M7 19 L7 25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
    </svg>
  );
}

export function AcupunctureIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path d="M20 4 L20 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M20 4 L17 10 L23 10 Z" fill="currentColor" opacity="0.8" />
      <circle cx="13" cy="20" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="27" cy="16" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="13" cy="28" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="28" cy="26" r="2" fill="currentColor" opacity="0.5" />
    </svg>
  );
}

export function PsychologyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M20 8 C14 8 8 13 8 19 C8 25 13 30 20 30 C27 30 32 25 32 19 C32 13 26 8 20 8 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      <line x1="20" y1="8" x2="20" y2="30" stroke="currentColor" strokeWidth="1.5" opacity="0.35" />
      <path d="M11 17 C13 14 16 15 15 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path d="M29 17 C27 14 24 15 25 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <path
        d="M17 30 Q18 34 20 35 Q22 34 23 30"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.6"
      />
    </svg>
  );
}

export function MentalHealthIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M20 34 C19 33 6 24 6 15 C6 10 10 7 14 7 C17 7 19 9 20 11 C21 9 23 7 26 7 C30 7 34 10 34 15 C34 24 21 33 20 34 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      <circle cx="20" cy="17" r="3" fill="currentColor" opacity="0.5" />
      <path d="M14 27 C14 23 17 21 20 21 C23 21 26 23 26 27" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}

export function OccupationalTherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="20" cy="7" r="4" fill="currentColor" opacity="0.8" />
      <line x1="20" y1="11" x2="20" y2="23" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.75" />
      <path d="M20 14 L9 19 L8 24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.7" />
      <path d="M20 14 L31 19 L32 24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.7" />
      <path d="M20 23 L16 34" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <path d="M20 23 L24 34" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <circle cx="8"  cy="24" r="2" stroke="currentColor" strokeWidth="1.5" opacity="0.5" />
      <circle cx="32" cy="24" r="2" stroke="currentColor" strokeWidth="1.5" opacity="0.5" />
    </svg>
  );
}

export function SpeechTherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M7 6 Q7 4 10 4 L30 4 Q33 4 33 7 L33 22 Q33 25 30 25 L23 25 L17 32 L17 25 L10 25 Q7 25 7 22 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      <line x1="13" y1="12" x2="27" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
      <line x1="13" y1="18" x2="23" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.45" />
    </svg>
  );
}

export function PodiatryIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <ellipse cx="20" cy="33" rx="7.5" ry="5" stroke="currentColor" strokeWidth="2" opacity="0.8" />
      <ellipse cx="20" cy="20" rx="9" ry="6" stroke="currentColor" strokeWidth="2" opacity="0.75" />
      <path d="M11 26 Q9 26 11 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
      <path d="M29 26 Q31 26 29 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
      <circle cx="12" cy="11" r="2.5" fill="currentColor" opacity="0.6" />
      <circle cx="17" cy="9"  r="3"   fill="currentColor" opacity="0.65" />
      <circle cx="23" cy="9"  r="3"   fill="currentColor" opacity="0.65" />
      <circle cx="28" cy="11" r="2.5" fill="currentColor" opacity="0.6" />
      <circle cx="31" cy="15" r="2"   fill="currentColor" opacity="0.5" />
    </svg>
  );
}

export function NutritionDieteticsIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M20 11 C13 11 7 16 7 23 C7 31 13 37 19 37 Q20 37 21 37 C27 37 33 31 33 23 C33 16 27 11 20 11 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.85"
      />
      <path d="M17 12 Q20 10 23 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
      <path d="M20 11 Q21 6 25 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.65" />
      <path d="M22 8 Q27 4 28 8 Q24 10 22 8 Z" fill="currentColor" opacity="0.55" />
    </svg>
  );
}

export function NaturopathyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M20 36 Q8 30 8 18 Q8 6 20 4 Q32 6 32 18 Q32 30 20 36 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.85"
      />
      <line x1="20" y1="36" x2="20" y2="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.45" />
      <path d="M20 14 L13 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <path d="M20 14 L27 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <path d="M20 23 L13 27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <path d="M20 23 L27 27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
    </svg>
  );
}

export function SportsTherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="29" cy="6" r="3.5" fill="currentColor" opacity="0.8" />
      <path d="M27 10 L21 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.75" />
      <path d="M25 13 L17 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <path d="M24 16 L32 13" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <path d="M21 20 L14 30 L11 36" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <path d="M21 20 L25 30 L29 36" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <path d="M6 22 L11 13 L9 21 L14 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
    </svg>
  );
}

export function PilatesIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <line x1="4" y1="35" x2="36" y2="35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
      <path d="M8 35 L8 27" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.75" />
      <path d="M17 35 L17 24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.75" />
      <path
        d="M8 27 Q11 15 20 12 Q29 9 33 17"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.85"
      />
      <path d="M33 17 L35 24 L36 31" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <circle cx="36" cy="31" r="3.5" stroke="currentColor" strokeWidth="2" opacity="0.7" />
      <path d="M8 27 L5 29 M17 24 L6 25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}

export function YogaTherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="20" cy="7" r="4" fill="currentColor" opacity="0.8" />
      <line x1="20" y1="11" x2="20" y2="23" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.75" />
      <path d="M20 16 L10 23" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <path d="M20 16 L30 23" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
      <path
        d="M20 23 Q13 25 8 32 Q14 35 20 32 Q26 35 32 32 Q27 25 20 23"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.75"
      />
      <circle cx="10" cy="23" r="1.8" fill="currentColor" opacity="0.5" />
      <circle cx="30" cy="23" r="1.8" fill="currentColor" opacity="0.5" />
    </svg>
  );
}

export function ReflexologyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M15 36 Q8 35 8 26 L8 14 Q8 6 14 5 Q20 5 20 12 L20 17 Q20 19 22 19 Q26 19 27 16 Q29 11 32 13 Q35 16 31 20 L29 22 Q27 24 27 28 L27 34 Q27 36 22 36 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      <circle cx="13" cy="15" r="2" fill="currentColor" opacity="0.55" />
      <circle cx="13" cy="23" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="14" cy="31" r="2" fill="currentColor" opacity="0.45" />
    </svg>
  );
}

export function DermatologyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="16" cy="16" r="11" stroke="currentColor" strokeWidth="2.5" opacity="0.85" />
      <line x1="24" y1="24" x2="34" y2="34" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.75" />
      <circle cx="12" cy="13" r="2.5" fill="currentColor" opacity="0.3" />
      <circle cx="19" cy="12" r="2.5" fill="currentColor" opacity="0.3" />
      <circle cx="15" cy="20" r="2.5" fill="currentColor" opacity="0.3" />
    </svg>
  );
}

export function OptometryIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <path
        d="M4 20 Q12 8 20 8 Q28 8 36 20 Q28 32 20 32 Q12 32 4 20 Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.85"
      />
      <circle cx="20" cy="20" r="7" stroke="currentColor" strokeWidth="2" opacity="0.7" />
      <circle cx="20" cy="20" r="3.5" fill="currentColor" opacity="0.6" />
    </svg>
  );
}

export function KinotherapyIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="28" cy="7" r="3.5" fill="currentColor" opacity="0.8" />
      <path
        d="M25 11 L20 20 L14 16 L10 26"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 20 L22 30 L18 34"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 30 L28 33" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

// ─── Utility icons ─────────────────────────────────────────────────────────────

export function DefaultIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <rect x="16" y="6"  width="8" height="28" rx="3" fill="currentColor" opacity="0.5" />
      <rect x="6"  y="16" width="28" height="8" rx="3" fill="currentColor" opacity="0.5" />
    </svg>
  );
}

export function AddIcon() {
  return (
    <svg viewBox="0 0 40 40" fill="none" className="h-8 w-8" aria-hidden="true">
      <circle cx="20" cy="20" r="14" stroke="currentColor" strokeWidth="2" opacity="0.5" />
      <path
        d="M20 13 L20 27 M14 20 L26 20"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      className="h-4 w-4"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    >
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  );
}

// ─── Registry ──────────────────────────────────────────────────────────────────

export const ICONS: Record<string, ReactNode> = {
  stethoscope:            <StethoscopeIcon />,
  physiotherapy:          <PhysiotherapyIcon />,
  'massage-therapy':      <MassageTherapyIcon />,
  osteopathy:             <OsteopathyIcon />,
  chiropractic:           <ChiropracticIcon />,
  acupuncture:            <AcupunctureIcon />,
  psychology:             <PsychologyIcon />,
  'mental-health':        <MentalHealthIcon />,
  'occupational-therapy': <OccupationalTherapyIcon />,
  'speech-therapy':       <SpeechTherapyIcon />,
  podiatry:               <PodiatryIcon />,
  'nutrition-dietetics':  <NutritionDieteticsIcon />,
  naturopathy:            <NaturopathyIcon />,
  'sports-therapy':       <SportsTherapyIcon />,
  pilates:                <PilatesIcon />,
  'yoga-therapy':         <YogaTherapyIcon />,
  reflexology:            <ReflexologyIcon />,
  dermatology:            <DermatologyIcon />,
  optometry:              <OptometryIcon />,
  // Legacy / alternate codes
  kinotherapy:            <KinotherapyIcon />,
  massage:                <MassageTherapyIcon />,
  osteopath:              <OsteopathyIcon />,
};

export function getIcon(code: string | null | undefined): ReactNode {
  if (!code) return <DefaultIcon />;
  return ICONS[code] ?? <DefaultIcon />;
}
